import { render, staticRenderFns } from "./MarkdownElementSettings.vue?vue&type=template&id=415c1df5&scoped=true&"
import script from "./MarkdownElementSettings.vue?vue&type=script&lang=ts&"
export * from "./MarkdownElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c1df5",
  null
  
)

export default component.exports